import axios from "axios";
import { getRequestHeaders } from "src/utils/TokenUtils";

export const fetchSecPortalApi = async (encryptEmail: any, source: any) => {
  const SEC_PORTAL_API_URL = `${import.meta.env.VITE_APP_BASE_URL}/ux/v1/content`;

  return axios.post(
    SEC_PORTAL_API_URL,
    {
      encryptEmail,
      source,
    },

    getRequestHeaders(SEC_PORTAL_API_URL)
  );
};

export const fetchAdfsTokenDetails = async () => {
  const TOKEN_URL = `${import.meta.env.VITE_APP_TOKEN_URL}`;
  //const TOKEN_URL= '/ux/token'
  return axios.get(TOKEN_URL);
};

export const authenticateUser = async (payload: any) => {
  const ACH_AUTHENTICATE_USER_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/v1/validate/email`;
  return axios.post(ACH_AUTHENTICATE_USER_URL, payload, getRequestHeaders(ACH_AUTHENTICATE_USER_URL));
};

export const resendAccessCode = async (payload: any) => {
  const ACH_AUTHENTICATE_USER_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/v1/resend/otp`;
  return axios.post(ACH_AUTHENTICATE_USER_URL, payload, getRequestHeaders(ACH_AUTHENTICATE_USER_URL));
};

export const verifyOtp = async (payload: any) => {
  const ACH_VERIFY_OTP_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/v1/verify/otp`
  return axios.post(
    ACH_VERIFY_OTP_URL,
    payload,
    getRequestHeaders(ACH_VERIFY_OTP_URL)
  );
};

export const postACHEnrollmentProvideInfo = async (payload: any) => {
  const ACH_SUBMIT_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/ach/v2/submit`;
  return axios.post(ACH_SUBMIT_URL, payload, getRequestHeaders(ACH_SUBMIT_URL));
};

export const getAchDataKey = async () => {
  const ACH_DATA_KEY_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/ach/v1/data-key`;
  return axios.get(ACH_DATA_KEY_URL, getRequestHeaders(ACH_DATA_KEY_URL));
};


export const clearSession = async (payload: any) => {
  const ACH_CLEAR_SESSION_URL = `${import.meta.env.VITE_APP_BASE_URL}/onboard/ux/v1/session/clear`;

  return axios.post(ACH_CLEAR_SESSION_URL, payload, getRequestHeaders(ACH_CLEAR_SESSION_URL));
};